module.exports = __webpack_public_path__ + "img/229-c94e09.png";